export default __webpack_public_path__ + "images/de17510bc966aa7da5f68d6b00b0db76-brain_icon.png";